import React from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

import { isMobile } from '../util';

export function ResponsiveTableRow (props) {
  const { url, className, ...extraProps } = props;
  const Container = url ? Link : 'div';
  return isMobile() ? (
    <Container to={url} {...{ ...extraProps, className: classnames(className, 'card p-2 mb-2'), }}>
      <div className="d-flex flex-wrap">
        {props.children}
      </div>
    </Container>
  ) : (
    <tr {...props}>
      {props.children}
    </tr>
  );
}

export function ResponsiveTableColumn (props) {
  const { url, className, ...extraProps } = props;
  const Container = url ? Link : 'div';
  return isMobile() ? (
    <div {...{ ...props, className: classnames(className, 'p-2'), }}>
      <div className="text-muted small">
        {props.label}
      </div>
      <div className="text-dark">
        {props.children}
      </div>
    </div>
  ) : (
    <td {...props}>
      {props.children}
    </td>
  );
}
